'use client';

const getCurrentState = ({
  disabled,
  error
}) => {
  if (disabled) return "disabled";
  if (error) return "invalid";
  return "regular";
};
export {
  getCurrentState
};
